import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

export interface ISort extends IIcon {
  sort?: 'ASC' | 'DESC' | undefined;
}

const Sort: React.FC<ISort> = ({ sort, size = 24, alt, color, className, onClick }) => {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  const secondaryColor = theme.colors.grey70_1;

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      onClick={onClick}
      className={className}
      color={color}
      data-testid={`sort-icon-sort-order-${sort}`}>
      <path
        d='M15.1414 16.1527V9.39355H13.2358V16.1527H10.3772L14.1886 20L18 16.1527H15.1414Z'
        fill={(sort === 'ASC' && secondaryColor) || (sort === 'DESC' && fillColor) || secondaryColor}
      />
      <path
        d='M9.81141 4L6 7.84723H8.85857V14.6064H10.7642V7.84723H13.6228L9.81141 4Z'
        fill={(sort === 'ASC' && fillColor) || (sort === 'DESC' && secondaryColor) || secondaryColor}
      />
    </svg>
  );
};

export default Sort;
